/**
 * Badge Component
 * Pure presentation component for status badges.
 */

import type { ReactNode } from 'react';

export interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info';
  className?: string;
}

const variantClasses = {
  default: 'bg-[var(--surface-bg-active)] text-[var(--surface-text-primary)]',
  success: 'bg-[var(--color-success-500)] text-white',
  warning: 'bg-[var(--color-warning-500)] text-white',
  error: 'bg-[var(--color-error-500)] text-white',
  info: 'bg-[var(--color-accent-500)] text-white',
};

export function Badge({
  children,
  variant = 'default',
  className = '',
}: BadgeProps) {
  const baseClasses = 'inline-flex items-center px-[var(--space-2)] py-[var(--space-1)] rounded-[var(--radius-md)] text-[var(--text-xs)] font-medium';
  const classes = `${baseClasses} ${variantClasses[variant]} ${className}`.trim();

  return <span className={classes}>{children}</span>;
}
